// extracted by mini-css-extract-plugin
module.exports = {"gdpr__consent-text":"gdpr__consent-text__1K91W","gdpr__instructions":"gdpr__instructions__lHoQt"};